import React from 'react';

import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';

import { type SettingsMenuItem } from '@fd/ui/List/SettingsList';

import { PortalFeatureFlags } from '../../services/featureFlags/portalFeatureFlags';
import { useFeatureFlagValue } from '../../services/featureFlags/useFeatureFlagValue';

type PhoneNumbersPageTarget = {
  appId: string;
  propertyId: string;
};

/** The phone agent MFE's property-scoped Phone numbers page. */
export const getPhoneNumbersPagePath = ({ appId, propertyId }: PhoneNumbersPageTarget) =>
  `/${appId}/phone-agent/properties/${propertyId}/phone-numbers`;

/**
 * When on, the Phone numbers page is the only place phone numbers are edited: the legacy property,
 * store and sales channel phone editors are hidden and settings lists link to the page instead.
 */
export const useIsPhoneNumbersPageOn = () =>
  useFeatureFlagValue(PortalFeatureFlags.phoneAgentNumbersPage, false);

export const getPhoneNumbersMenuItem = ({
  appId,
  propertyId,
  ...rest
}: PhoneNumbersPageTarget &
  Omit<Partial<SettingsMenuItem>, 'title' | 'path' | 'propertyId'>): SettingsMenuItem => ({
  title: 'Phone_numbers',
  subtitle: 'Phone_numbers_settings_subtitle',
  icon: <LocalPhoneOutlinedIcon />,
  labels: [{ translationId: 'New', tone: 'information' }],
  searchAlias: ['Phone number', 'Property phone', 'Phone agent number', 'Call answering'],
  ...rest,
  path: getPhoneNumbersPagePath({ appId, propertyId }),
  propertyId,
});
